export default function Youtube(props) {
    const fill = props.fill ?? '#212121';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-21 -117 682.7 682">
            <path
                fill={fill}
                d="M627 64c-8-27-29-49-57-56C520-6 320-6 320-6S120-6 70 7c-27 7-49 30-57 57C0 114 0 218 0 218s0 104 13 154c8 27 29 49 57 56 50 14 250 14 250 14s200 0 250-13c28-8 49-29 57-57 13-50 13-154 13-154s1-104-13-154zM256 314V122l167 96zm0 0"
            />
        </svg>
    );
}
